import { Colors, Icon } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";

export function GroupSuggestionItem({ suggestion }) {
  return (
    <Flex alignItems="center">
      <Icon
        icon="people"
        color={Colors.GRAY3}
        css={{
          marginRight: "4px",
        }}
      />
      <Box>{suggestion.name}</Box>
    </Flex>
  );
}
